var render = function render(){var _vm=this,_c=_vm._self._c;return _c('bean-source-page',{attrs:{"type":_vm.type,"columns":_vm.columns,"form-columns":_vm.formColumns,"filter-columns":_vm.filterColumns,"onFetchData":_vm.onFetchData,"actions":_vm.actions,"onFormSubmit":_vm.handleSubmit,"form":_vm.form,"title":"站点设置","resource":"settings"}})
}
var staticRenderFns = []

export { render, staticRenderFns }